module.exports = __webpack_public_path__ + "img/ruinehohenurach.40667e56.jpg";